import { createContext, ReactNode, useContext, useState } from "react";
import { useMatch } from "react-router-dom";

type LayoutProviderProps = {
  offsetTop?: number | null;
  children?: ReactNode;
};

type LayoutContextType = {
  offsetTop: number;
  setOffsetTop: (newOffsetTop: number) => void;
  hasSidebar: boolean;
};

const initialValue = {
  offsetTop: 0,
  setOffsetTop: () => {},
  hasSidebar: false,
};

const LayoutContext = createContext<LayoutContextType>(initialValue);

export const LayoutProvider = ({ children, ...props }: LayoutProviderProps) => {
  const [offsetTop, setOffsetTop] = useState<number>(props.offsetTop ?? 0);
  const dashboardEditorMatch = useMatch("/:workspaceUrl/public-dashboards/:dashboardId/edit");
  const componentEditorMatch = useMatch("/:workspaceUrl/public-dashboards/components/:dashboardId/edit");
  const isDashboardEditor = !!(dashboardEditorMatch || componentEditorMatch);
  const hasSidebar = !isDashboardEditor;

  return (
    <LayoutContext.Provider
      value={{
        offsetTop,
        setOffsetTop,
        hasSidebar,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = (): LayoutContextType => {
  const context = useContext(LayoutContext);

  if (!context) {
    throw new Error("useLayout must be used within LayoutProvider");
  }

  return context;
};
